import { render, staticRenderFns } from "./FoodDialog.vue?vue&type=template&id=0b568b6e&scoped=true"
import script from "./FoodDialog.vue?vue&type=script&lang=js"
export * from "./FoodDialog.vue?vue&type=script&lang=js"
import style0 from "./FoodDialog.vue?vue&type=style&index=0&id=0b568b6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b568b6e",
  null
  
)

export default component.exports